<template>
  <v-card-actions class="pa-0">
    <v-spacer></v-spacer>
      <v-tooltip bottom>
      <v-btn slot="activator" icon flat small @click="goInforme" class="pa-0 ma-0 mt-1" :disabled="!clubPuedeVer">
          <v-icon :color="item.canView ? 'primary' : 'error'">keyboard_arrow_right</v-icon>
      </v-btn>
        <span v-if="!clubPuedeVer">El informe está siendo corregido por LPF</span>
        <span v-else>Ver informe</span>
      </v-tooltip>
  </v-card-actions>
</template>

<script>
export default {
  props: {
    item: Object
  },

  computed: {
    clubPuedeVer () {
      return this.item.canView || this.$store.getters.isSafRole
    }
  },

  methods: {
    goInforme () {
      this.$router.push({ name: 'informe-pagos', params: { id: this.item.pk } })
    }
  }
}
</script>
